import {writable} from "svelte/store";

const store = writable("EN");

class Language {
  get store() {
    return store;
  }
}

export default Language;